import type { ReactNode } from 'react';
import { Tooltip, Typography } from 'antd';
import type { TableProps } from 'antd';
import { formatHongKongPhoneDisplay } from '../firebase/phone';

export const CRM_TABLE_CLASS = 'crm-data-table';

/** 列表共通：細行距、頂部對齊、橫向捲動 */
export function crmTableProps(scrollX = 960): Pick<TableProps, 'className' | 'size' | 'scroll'> {
  return {
    className: CRM_TABLE_CLASS,
    size: 'small',
    scroll: { x: scrollX },
  };
}

export function CrmPhoneText({ phone }: { phone: string | null | undefined }) {
  if (!phone?.trim()) return <>—</>;
  return <span className="crm-cell-nowrap">{formatHongKongPhoneDisplay(phone)}</span>;
}

export function CrmTwoLine({
  primary,
  secondary,
}: {
  primary: ReactNode;
  secondary?: ReactNode;
}) {
  return (
    <div className="crm-two-line">
      <div className="crm-two-line-primary">{primary}</div>
      {secondary != null && secondary !== '' ? (
        <Typography.Text type="secondary" className="crm-two-line-sub">
          {secondary}
        </Typography.Text>
      ) : null}
    </div>
  );
}

/** 地址欄：最多兩行，hover 顯示全文 */
export function CrmAddressCell({ address }: { address: string | null | undefined }) {
  return <CrmEllipsisText text={address} lines={2} />;
}

export function CrmEllipsisText({
  text,
  lines = 2,
}: {
  text: string | null | undefined;
  lines?: 1 | 2 | 3;
}) {
  const value = text?.trim() || '—';
  if (value === '—') return <>—</>;
  return (
    <Tooltip title={value} placement="topLeft">
      <Typography.Paragraph
        ellipsis={{ rows: lines, tooltip: false }}
        style={{ marginBottom: 0, wordBreak: 'break-word' }}
      >
        {value}
      </Typography.Paragraph>
    </Tooltip>
  );
}
